export const printPurchasePaymentThermal = (paymentData) => {
  const printWindow = window.open('', '_blank');
  
  const printContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Purchase Payment Receipt</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { 
          font-family: 'Courier New', monospace; 
          font-size: 12px;
          line-height: 1.2;
          width: 80mm;
          margin: 0;
          padding: 0;
          background: white;
        }
        .receipt { 
          width: 100%;
          text-align: center;
          padding: 5px;
        }
        .company { font-size: 14px; font-weight: bold; margin-bottom: 2px; }
        .contact { font-size: 10px; margin-bottom: 1px; }
        .title { font-size: 12px; font-weight: bold; margin: 5px 0; }
        .line { display: flex; justify-content: space-between; margin: 1px 0; font-size: 11px; }
        .dash { border-top: 1px dashed #000; margin: 3px 0; }
        .center { text-align: center; }
        .bold { font-weight: bold; }
        @media print {
          body { width: 80mm; margin: 0; padding: 0; }
          @page { size: 80mm auto; margin: 0; }
        }
      </style>
    </head>
    <body>
      <div class="receipt">
        <div class="company">Sedis Niazi Wholesale</div>
        <div class="contact">📞 +93 70 285 0840 - +93 70 44 56 11 94</div>
        
        <div class="title">═══ PURCHASE PAYMENT RECEIPT ═══</div>
        
        <div class="line">
          <span>Receipt:</span>
          <span>${paymentData?.receiptNumber || Math.floor(Math.random() * 9999)}</span>
        </div>
        <div class="line">
          <span>Date:</span>
          <span>${paymentData?.date || new Date().toLocaleDateString()}</span>
        </div>
        <div class="line">
          <span>Time:</span>
          <span>${new Date().toLocaleTimeString()}</span>
        </div>
        
        <div class="dash"></div>
        
        <div class="line">
          <span>Supplier:</span>
          <span>${paymentData?.supplierName || 'Cash'}</span>
        </div>
       
        <div class="line">
          <span>Paid:</span>
          <span>${paymentData?.requestedAmount || '0.00'} ${paymentData?.currencySymbol || 'AF'}</span>
        </div>
       
        <div class="line">
          <span>Currency:</span>
          <span>${paymentData?.currencySymbol || 'AF'}</span>
        </div>
        
        ${paymentData?.notes ? `<div class="line">
          <span>Notes:</span>
          <span>${paymentData.notes}</span>
        </div>` : ''}
        
        <div class="center" style="margin-top: 10px; font-size: 10px;">
          Thank you!<br>
          ${new Date().getFullYear()} © Sedis Niazi Wholesale<br>
          <span style="font-size:9px;">Powered by Afghan Cosmos IT Solutions | www.afghancosmos.com</span>
        </div>
      </div>
      
      <script>
        window.onload = function() {
          setTimeout(() => {
            window.print();
            window.close();
          }, 5000000);
        };
      </script>
    </body>
    </html>
  `;
  
  printWindow.document.write(printContent);
  printWindow.document.close();
};

// Thermal receipt for purchase payment with purchase object
export const printPurchasePaymentThermalData = (purchase, paymentAmount) => {
  const printWindow = window.open('', '_blank');
  
  const formatCurrency = (currencyObj) => {
    if (!currencyObj) return "0.00";
    if (typeof currencyObj === 'object') {
      return String(Object.values(currencyObj)[0] || "0.00");
    }
    return String(currencyObj);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };
  
  const printContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Purchase Payment Receipt</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { 
          font-family: 'Courier New', monospace; 
          font-size: 12px;
          line-height: 1.2;
          width: 80mm;
          margin: 0;
          padding: 0;
          background: white;
        }
        .receipt { 
          width: 100%;
          text-align: center;
          padding: 5px;
        }
        .company { font-size: 14px; font-weight: bold; margin-bottom: 2px; }
        .contact { font-size: 10px; margin-bottom: 1px; }
        .title { font-size: 12px; font-weight: bold; margin: 5px 0; }
        .line { display: flex; justify-content: space-between; margin: 1px 0; font-size: 11px; }
        .dash { border-top: 1px dashed #000; margin: 3px 0; }
        .center { text-align: center; }
        .bold { font-weight: bold; }
        @media print {
          body { width: 80mm; margin: 0; padding: 0; }
          @page { size: 80mm auto; margin: 0; }
        }
      </style>
    </head>
    <body>
      <div class="receipt">
        <div class="company">Sedis Niazi Wholesale</div>
        <div class="contact">📞 +93 70 285 0840 - +93 70 44 56 11 94</div>
        
        <div class="title">═══ PURCHASE PAYMENT RECEIPT ═══</div>
        
        <div class="line">
          <span>Purchase:</span>
          <span>#${purchase.id}</span>
        </div>
        <div class="line">
          <span>Date:</span>
          <span>${formatDate(purchase.purchase_date)}</span>
        </div>
        <div class="line">
          <span>Time:</span>
          <span>${new Date().toLocaleTimeString()}</span>
        </div>
        
        <div class="dash"></div>
        
        <div class="line">
          <span>Supplier:</span>
          <span>${purchase.supplier_details?.name || 'Cash'}</span>
        </div>
        
        <div class="dash"></div>
        <div class="center bold">PAYMENT DETAILS</div>
        <div class="dash"></div>
        
      
        <div class="line">
          <span>Paid Before:</span>
          <span>${formatCurrency(purchase.total_paid)} AF</span>
        </div>
        <div class="line">
          <span>Payment Now:</span>
          <span>${paymentAmount || '0.00'} AF</span>
        </div>
        
        <div class="dash"></div>
       
        <div class="dash"></div>
        
        <div class="center" style="margin-top: 10px; font-size: 10px;">
          Thank you!<br>
          ${new Date().getFullYear()} © Sedis Niazi Wholesale<br>
          <span style="font-size:9px;">Powered by Afghan Cosmos IT Solutions | www.afghancosmos.com</span>
        </div>
      </div>
      
      <script>
        window.onload = function() {
          setTimeout(() => {
            window.print();
            window.close();
          }, 100000000);
        };
      </script>
    </body>
    </html>
  `;
  
  printWindow.document.write(printContent);
  // printWindow.document.close();
};
